import { Children, cloneElement } from 'react'
import clsx from 'clsx'
import { ChevronDownIcon } from '@/assets/icons'
import { SidebarItem, SidebarLabel } from '@/components/catalyst-ui/sidebar'

export function CollapsibleSidebarItem({
  label,
  icon,
  expanded,
  onToggle,
  children,
  className,
  showIndicator = true,
  labelClassName,
  current,
  closeSidebar,
  trailing,
  collapsible = false,
  ...props
}) {
  return (
    <div className={clsx(className, 'overflow-visible')}>
      <SidebarItem onClick={onToggle} showIndicator={showIndicator} current={current} disableIndicatorAnimation={true} collapsible={collapsible} {...props}>
        {icon}
        <SidebarLabel className={labelClassName}>{label}</SidebarLabel>
        <span data-sidebar-trailing className="ml-auto flex items-center gap-2">
          {trailing}
          <ChevronDownIcon
            className={clsx(
              'size-4 transition-transform duration-200',
              expanded ? 'rotate-180 text-black' : 'text-[#71717A]'
            )}
          />
        </span>
      </SidebarItem>
      {expanded && (
        <div data-sidebar-children className="ml-6 space-y-1 mt-1">
          {Children.toArray(children)
            .filter(child => child != null)
            .map(child => {
              const existingOnClick = child.props.onClick
              const handleClick = (e) => {
                if (existingOnClick) {
                  existingOnClick(e)
                } else if (closeSidebar) {
                  closeSidebar()
                }
              }
              return cloneElement(child, { showIndicator: false, onClick: handleClick })
            })
          }
        </div>
      )}
    </div>
  )
}
